module.exports = __webpack_public_path__ + "static/img/smartstation1.24f1cb30.png";